import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import styles from "../Component/CallDetails/CallDetails.module.css";
import Loader2 from "../Component/Loader2/Loader2";
import DetailModal from "../Component/DetailModal/DetailModal";
import { DateTime } from "luxon";

const PublicCall = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [callData, setCallData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [isChatModalOpen, setChatModalOpen] = useState(false);
  const [audioProgress, setAudioProgress] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [agents, setAgents] = useState(null);
  const fetchCallDetails = async () => {
    // alert("ok");/
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/public-call/${token}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.success) {
        setCallData(response.data.call || []);
        setAgents(response.data.agent || []);
      } else {
        setError(response.data.message || "Error fetching call details");
      }
    } catch (err) {
      setError("Error fetching call details. Please try again.");
      console.error("Error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCallDetails();
  }, []);

  const toggleAudio = () => {
    const audio = audioRef.current;
    if (!audio) return;
    if (audio.paused) {
      audio.play();
      setIsPlaying(true);
    } else {
      audio.pause();
      setIsPlaying(false);
    }
  };

  const handleAudioProgress = () => {
    const audio = audioRef.current;
    if (audio) {
      const progress = (audio.currentTime / audio.duration) * 100;
      setAudioProgress(progress);
      setCurrentTime(audio.currentTime);
    }
  };

  const handleSeek = (event) => {
    const audio = audioRef.current;
    const seekTime = (event.target.value / 100) * audio.duration;
    audio.currentTime = seekTime;
  };

  const formatTime = (timeInSeconds) => {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = Math.floor(timeInSeconds % 60);
    return `${minutes < 10 ? "0" : ""}${minutes}:${
      seconds < 10 ? "0" : ""
    }${seconds}`;
  };

  const getTimeFromTimestamp = () => {
    if (!callData?.end_timestamp) return "-";
    return DateTime.fromMillis(callData?.end_timestamp).toFormat("hh:mm:ss a");
  };

  const getDateFromTimestamp = () => {
    if (!callData?.end_timestamp) return "-";
    return DateTime.fromMillis(callData?.end_timestamp).toFormat("yyyy-MM-dd");
  };

  const formatName = (name) => {
    if (!name) return "";
    const firstName = name.split(" ")[0];
    return firstName.length <= 7
      ? firstName
      : firstName.substring(0, 10) + "...";
  };

  let data = callData?.call_analysis?.custom_analysis_data || [];
  let name = data?.name || "";
  const transcript = callData?.transcript_object || [];
  let lead_type = data?.lead_type || "";
  const currentAgent = callData?.agent_id;
  const convertMsToMinSec = (durationMs) => {
    const minutes = Math.floor(durationMs / 60000);
    const seconds = Math.floor((durationMs % 60000) / 1000);
    return `${minutes} Min ${seconds} Sec`;
  };
  if (loading) return <Loader2 />;
  if (error) return <div>{error}</div>;

  return (
    <div className={styles.CallDetailsMain}>
      <div className={styles.forSticky}>
        <header className={styles.header}>
          <div className={styles.profileBack}>
          

            <h4 className={styles.headerTitle}>Call Details</h4>
          </div>
        </header>
        <div className={styles.agentCard}>
          <div className={styles.details}>
            <p>Caller Name</p>
            <p>Sentiment</p>
          </div>
          <div className={styles.detail2}>
            <div className={styles.userName}>
              <h2>
                {name ||
                  callData?.retell_llm_dynamic_variables?.user_name ||
                  "Unknown"}
              </h2>
            </div>
            <div
              className={`${styles.status} ${
                callData.call_analysis?.user_sentiment === "Positive"
                  ? styles.green
                  : callData.call_analysis?.user_sentiment === "Neutral"
                  ? styles.yellow
                  : styles.red
              }`}
            >
              <p>{callData.call_analysis?.user_sentiment || "N/A"}</p>
            </div>
          </div>
          <hr className={styles.hrline} />
          <div className={styles.details3}>
            <div className={styles.Part1}>
              <p>{getTimeFromTimestamp()}</p>
              <strong>{getDateFromTimestamp()}</strong>
            </div>
            <div className={styles.Part2}>
              <p>Attended by</p>
              <strong>{agents.agentName || "Unknown Agent"}</strong>
            </div>

            <div className={styles.Part3}>
              <p>Durations</p>

              <strong>
                {/* {callData?.chat_type == "api_chat"
                  ? callData?.duration_ms || 0
                  : convertMsToMinSec(callData.duration_ms)} */}
                {convertMsToMinSec(callData.duration_ms)}
              </strong>
            </div>
          </div>
        </div>
      </div>

      <section>
        <div className={styles.DataMain}>
          <div className={styles.dataTitle}>
            <h2>Data Collected</h2>
          </div>
          <div className={styles.dataCard}>
            <div className={styles.PhoneNumber}>
              <p>Phone number</p>
              <b>
                {data?.phone_number ||
                  callData?.retell_llm_dynamic_variables?.user_phone ||
                  callData?.retell_llm_dynamic_variables?.customer_phone ||
                  "-"}
              </b>
            </div>
            <div className={styles.EmailAddress}>
              <p>Email address</p>
              <b>
                {data?.email ||
                  callData?.retell_llm_dynamic_variables?.user_email ||
                  "-"}
              </b>
            </div>
            <div className={styles.Address}>
              <p>Address (if collected)</p>
              <b>{data?.address ? data?.address : "-"}</b>
            </div>
            <div className={styles.Reason}>
              <p>Reason</p>
              <b>{data?.reason ? data?.reason : "-"}</b>
            </div>
          </div>
          <div className={styles.moredetailsDiv}>
            <div className={styles.dataTitle}>
              <h2>More Details</h2>
            </div>
            <div></div>
            <div className={styles.channel}>
              <p className={styles.Ptext}>Channel</p>
              <div className={styles.PhoneDiv}>
                <p>
                  {callData?.call_type === "phone_call"
                    ? callData?.from_number
                    : callData?.call_type}{" "}
                </p>
              </div>
            </div>
            <div className={styles.channel}>
              <p className={styles.Ptext}>Lead Type</p>
              <div>
                <strong>{lead_type || "Unknown"}</strong>
              </div>
            </div>
            {/* {callData.chat_type == "api_chat" ? (
              "" */}
            {/* // ) : ( */}
            <div className={styles.channel}>
              <p className={styles.Ptext}>Call Recording</p>
              <div className={styles.audioPlayer}>
                <div onClick={toggleAudio} className={styles.playPauseBtn}>
                  {isPlaying ? (
                    // Pause Icon
                    <svg
                      width="30"
                      height="30"
                      viewBox="0 0 50 50"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="25" cy="25" r="25" fill="#EBE2FF" />
                      <rect
                        x="18"
                        y="17"
                        width="5"
                        height="18"
                        rx="2"
                        fill="#6524EB"
                      />
                      <rect
                        x="27"
                        y="17"
                        width="5"
                        height="18"
                        rx="2"
                        fill="#6524EB"
                      />
                    </svg>
                  ) : (
                    <svg
                      width="30"
                      height="30"
                      viewBox="0 0 50 50"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="25" cy="25" r="25" fill="#EBE2FF" />
                      <polygon points="20,17 35,25 20,33" fill="#6524EB" />
                    </svg>
                  )}
                </div>
                <input
                  type="range"
                  min="0"
                  max="100"
                  value={audioProgress}
                  onChange={handleSeek}
                  className={styles.audioSeek}
                />
                <div className={styles.audioTime}>
                  <span>{formatTime(currentTime)}</span> /{" "}
                  <span>{formatTime(audioRef.current?.duration || 0)}</span>
                </div>
                <audio
                  ref={audioRef}
                  src={callData.recording_url}
                  onEnded={() => setIsPlaying(false)}
                  onTimeUpdate={handleAudioProgress}
                />
              </div>
            </div>
            {/* // )} */}
          </div>
          <div className={styles.summaryDiv}>
            <div className={styles.dataTitle}>
              <h2>
                {/* {callData.chat_type == "api_chat"
                  ? "Chat summary"
                  : "Call summary"} */}
                Call summary
              </h2>
            </div>
            <p className={styles.Ptext}>
              {callData.call_analysis?.call_summary || "No data"}
            </p>
          </div>
          <div className={styles.summaryDiv}>
            <div className={styles.dataTitle}>
              <h2> Call Transcript</h2>
            </div>
            <div className={styles.ChatBox}>
              {transcript.find((msg) => msg.role === "agent") && (
                <div className={styles.messageRow}>
                  <div className={styles.profile}>
                    <img
                      src={
                        `/${agents?.avatar}` || "/svg/default-agent.svg"
                      }
                      alt="Agent"
                      className={styles.profileImage}
                    />
                  </div>

                  <div className={styles.messageLeft}>
                    <div className={styles.bubbleLeft}>
                      {transcript.find((msg) => msg.role === "agent").content}
                    </div>
                    <span className={styles.time}>
                      {agents.agentName || "Unknown Agent"}
                    </span>
                  </div>
                </div>
              )}

              {transcript.find((msg) => msg.role === "user") && (
                <div className={styles.messageRight}>
                  <div className={styles.bubbleRight}>
                    {transcript.find((msg) => msg.role === "user").content}
                  </div>
                  <span className={styles.time}>User</span>
                </div>
              )}

              <div
                className={styles.chatBtn}
                onClick={() => setChatModalOpen(true)}
              >
                <p>Show Full Transcript</p>
              </div>
            </div>

            <DetailModal
              isOpen={isChatModalOpen}
              onClose={() => setChatModalOpen(false)}
              height="80dvh"
            >
              <div className={styles.titlediv}>
                <h1>Call Transcript</h1>
              </div>
              <div className={styles.ChatBox2}>
                {transcript.map((entry, index) =>
                  entry.role === "agent" ? (
                    <div key={index} className={styles.messageWrapper}>
                      <div className={styles.messageLeftWrapper}>
                        <img
                          src={`/${agents?.avatar}` || "/svg/default-agent.svg"}
                          alt="Agent"
                          className={styles.profileImage}
                        />
                        <div className={styles.messageLeft}>
                          <div className={styles.bubbleLeft}>
                            {entry.content}
                          </div>
                          <span className={styles.time}>
                            {agents.agentName || "Unknown Agent"}
                          </span>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div key={index} className={styles.messageWrapper2}>
                      <div className={styles.messageRight}>
                        <div className={styles.bubbleRight}>
                          {entry.content}
                        </div>
                      </div>
                      <span className={styles.time}>User</span>
                    </div>
                  )
                )}
              </div>
            </DetailModal>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PublicCall;
